import React from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { reducer, sliceKey } from "./containers/Auth/slice";
import authSaga from "./containers/Auth/saga";

import {
  reducer as fieldsReducer,
  sliceKey as fieldsSliceKey,
} from "store/global/fields/slice";

import {
  reducer as authReducer,
  sliceKey as authSliceKey,
} from "store/global/authPermission/slice";

import { selectDirection } from "../styles/theme/slice";
import { AuthPermission } from "./components/AuthPermission";
import { selectIsLoggedIn } from "./containers/Auth/selectors";
import { AuthRoutes } from "./routes/auth-routes";
import { InterNalRoutes } from "./routes/internal-routes";
import { PagesRoutes } from "./routes/pages-routes";

export function App() {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: authSaga });

  useInjectReducer({ key: fieldsSliceKey, reducer: fieldsReducer });

  useInjectReducer({ key: authSliceKey, reducer: authReducer });

  // Logged in once login sets a session token
  const isLoggedIn = useSelector(selectIsLoggedIn);

  const direction = useSelector(selectDirection);

  return (
    <BrowserRouter>
      <Helmet titleTemplate="%s - Silagi" defaultTitle="Silagi">
        <meta name="description" content="A Silagi application" />
      </Helmet>
      <div dir={direction}>
        <Routes>
          <Route path="/auth/*" element={<AuthRoutes />} />
          <Route path="/pages/*" element={<PagesRoutes />} />
          {isLoggedIn ? <Route path="/*" element={<InterNalRoutes />} /> : null}
          <Route
            path="*"
            element={<Navigate to={isLoggedIn ? "/home" : "/auth/login"} replace />}
          />
        </Routes>
      </div>
      {isLoggedIn ? <AuthPermission /> : ""}
    </BrowserRouter>
  );
}
